import { CANVAS_LEFT_MARGIN, CANVAS_WIDTH } from '@constants/canvas/general';
import { themePalette } from '@theme/muiTheme';
import SublayerView from '@utils/canvas/SublayerView';
import styled from 'styled-components';

type SubLayerNodeProps = {
  $withBottomBorder: boolean;
  $stripeWidth: number;
  $height?: number;
};

export const SubLayerNodeStyled = styled('div')<SubLayerNodeProps>`
  position: relative;
  left: -${CANVAS_LEFT_MARGIN}px;
  width: ${CANVAS_WIDTH}px;
  height: ${({ $height }) => $height || SublayerView.InitialHeight}px;
  display: flex;
  padding-left: 24px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: transparent;

  &::after {
    content: '';
    border-bottom: ${(p) =>
      p.$withBottomBorder && `2px dashed ${themePalette.grey[600]}`};
    width: ${({ $stripeWidth }) => `${$stripeWidth}px`};
    position: fixed;
    bottom: 0;
    left: -${CANVAS_LEFT_MARGIN}px;
  }
`;

export const SubLayerName = styled('div')`
  position: absolute;
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 0;
  cursor: pointer;
`;
